import { Dir } from '../../dirs';
import http from '../../../utils/http';
import { Field, FieldUpdatePayload, UpdateFieldValuesPayload } from '../index';

export function fetchIntelligentFields({
  id,
  groups,
}: Pick<Dir, 'id'> & { groups?: string[] }) {
  return http.get<never, Field[]>(`api/intelligence-layer/${id}`, {
    params: groups?.length ? { groups } : undefined,
  });
}

export function fetchIntelligentFieldsForDirectories({
  ids,
  groups,
}: {
  ids: Dir['id'][];
  groups?: string[];
}) {
  return http.get<never, Field[]>('api/intelligence-layer/bulk', {
    params: {
      ids,
      ...(groups?.length ? { groups } : {}),
    },
  });
}

export function updateIntelligentFields({
  dirId,
  fields,
  groups,
}: UpdateFieldValuesPayload & { groups?: string[] }) {
  return http.put<never, void>(`api/intelligence-layer/${dirId}/sync`, fields, {
    params: groups?.length ? { groups } : undefined,
  });
}

export function updateIntelligentFieldsForDirectories({
  ids,
  groups,
  fields,
}: {
  ids: Dir['id'][];
  groups?: string[];
  fields: FieldUpdatePayload;
}) {
  return http.put<never, void>('api/intelligence-layer/bulk/sync', fields, {
    params: {
      ids,
      ...(groups?.length ? { groups } : {}),
    },
  });
}
